import licenze from '@/services/licenzeService.js'
import prodotti from '@/services/prodottiService.js'
import jwt from 'jsonwebtoken'

export const verificaLicenza = {
  data() {
    return {
      token: ''
    }
  },
  methods: {
    async gestioneToken() {
      this.token = localStorage.getItem('token')
      if (!this.token || this.isTokenExpired(this.token.replace(/['"]+/g, ''))) {
        const associazione = this.$route.query.associazione
        const udid = this.$route.query.udid
        localStorage.setItem('udid', udid)
        localStorage.setItem('associazione', associazione)
        let result = await fetch(`https://licenze.ubisell.ubi-co.com/devices/jwt?udid=${udid}&associazione=${associazione}`, {
          headers: {
            'x-sellogic-key': 'znKDKo5pOiiDpBOP3hu7f2gc01YxKYjYkUSXJ2pR'
          }
        })
        result = await result.json()
        this.token = result.token
      }
      // this.token = await licenze.getToken()
      if (this.isTokenValid(this.token)) {
        localStorage.setItem('token', this.token)
      } else {
        if (this.isTokenValid(localStorage.getItem('token'))) {
          try {
            this.token = JSON.parse(localStorage.getItem('token'))
            // console.log('token valido ---- ', this.token)
          } catch (e) {
            console.log('Errore gestione token da local storage', e.message)
            localStorage.removeItem('token')
            this.token = ''
          }
        } else {
          this.token = ''
          console.log('token non valido', localStorage.getItem('token'))
        }
      }
      const verifica = await licenze.verifyToken(this.token)
      const moduloFattureElettroniche = verifica && verifica.moduli && verifica.moduli.findIndex(x => x === 'fatturazioneElettronica') > -1
      if (moduloFattureElettroniche) {
        localStorage.setItem('display_fe', true)
      } else {
        localStorage.removeItem('display_fe')
      }
      // console.log(verifica)
      const event = null
      switch (verifica.stato) {
        case 'token.scaduto': // blocca l'applicazione
          this.$router.push('/token')
          break
        case 'token.inScadenza': // segnala di ricollegare
          this.context.displayMessage = `Ricordati di collegare la rete... Hai solo ${verifica.oreToken} ${verifica.oreToken === 1 ? 'ora' : 'ore'} per farlo`
          break
        case 'licenza.scaduta': // blocca l'applicazione
          this.$router.push('/licenza')
          break
        case 'licenza.inScadenza': // segnala di aggiornare la licenza
          this.context.displayMessage = `Attenzione! La licenza scade tra ${verifica.giorniLicenza} ${verifica.giorniLicenza === 1 ? 'giorno' : 'giorni'}...`
          break
        default:
          break
      }
      if (event) {
        this.displayService.send(event)
      } else {
        prodotti.setToken(this.token)
      }
    },
    // Send events to the service
    sendEvent(event) {
      this.displayService.send(event)
    },
    isTokenValid(token) {
      if (!token) return false
      if (Array.isArray(token) && token.length === 0) return false
      if (token === '') return false
      if (JSON.stringify(token) === '{}') return false
      return true
    },
    isTokenExpired(token) {
      const decoded = jwt.decode(token)
      if (!decoded.exp) {
        return false
      }
      const now = Date.now() / 1000
      return decoded.exp < now
    }
  }
}
